var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 33,
    viewBox: "0 0 85 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 31,
    height: 33,
    transform: "translate(1678 65)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-1678 -50)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Login",
    transform: "translate(1718 72)",
    fontSize: 18,
    fontFamily: "AvenirNext-Regular, Avenir Next",
    letterSpacing: "-0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Login")), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(0 -15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_435",
    "data-name": "Path 435",
    transform: "translate(1678 82)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,0A15.5,15.5,0,1,1,0,15.5,15.5,15.5,0,0,1,15.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.5 4 C 12.4282398223877 4 9.540340423583984 5.196210861206055 7.368270874023438 7.368270874023438 C 5.196210861206055 9.540340423583984 4 12.4282398223877 4 15.5 C 4 18.5717601776123 5.196210861206055 21.45965957641602 7.368270874023438 23.63172912597656 C 9.540340423583984 25.80379104614258 12.4282398223877 27 15.5 27 C 18.5717601776123 27 21.45965957641602 25.80379104614258 23.63172912597656 23.63172912597656 C 25.80379104614258 21.45965957641602 27 18.5717601776123 27 15.5 C 27 12.4282398223877 25.80379104614258 9.540340423583984 23.63172912597656 7.368270874023438 C 21.45965957641602 5.196210861206055 18.5717601776123 4 15.5 4 M 15.5 0 C 24.06040954589844 0 31 6.939590454101562 31 15.5 C 31 24.06040954589844 24.06040954589844 31 15.5 31 C 6.939590454101562 31 0 24.06040954589844 0 15.5 C 0 6.939590454101562 6.939590454101562 0 15.5 0 Z",
    stroke: "none",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(1683 65)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 8.5,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.23b8b4a1ee850efad6fd9e7f9d5108b3.svg";
export { ForwardRef as ReactComponent };